const endpoint = 'https://sdkserver.seasungame.com/api/clue';
const storageKey = 'sem_device_id';
let memoryDeviceId = '';

function getDeviceId() {
  if (memoryDeviceId) return memoryDeviceId;
  try {
    memoryDeviceId = window.localStorage.getItem(storageKey) || '';
  } catch (error) {
    memoryDeviceId = '';
  }
  if (!memoryDeviceId) {
    memoryDeviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
      const randomValue = Math.floor(Math.random() * 16);
      const value = character === 'x' ? randomValue : (randomValue & 3) | 8;
      return value.toString(16);
    });
    try {
      window.localStorage.setItem(storageKey, memoryDeviceId);
    } catch (error) {
      return memoryDeviceId;
    }
  }
  return memoryDeviceId;
}

export async function sendSemReport(eventId) {
  try {
    const currentUrl = new URL(window.location.href);
    const payload = {
      url: currentUrl.href,
      appId: '200001658',
      btAppId: '5891adafd625',
      deviceId: getDeviceId(),
      msgType: 'custom.event',
      eventId,
      _btcode: currentUrl.searchParams.get('_btcode') || 'null',
      bd_vid: currentUrl.searchParams.get('bd_vid') || 'null'
    };
    const body = encodeURIComponent(JSON.stringify(payload));
    const response = await window.fetch(`${endpoint}?body=${body}`);
    if (!response.ok) {
      throw new Error(`SEM HTTP ${response.status}`);
    }
    const data = await response.json();
    return { status: 'received', data };
  } catch (error) {
    return { status: 'failed', error };
  }
}
